import { useTranslation } from "react-i18next";
import { Chip } from "@/components/vroom/chip";

export interface UrenFilterChipState {
  costCenterId?: string;
  workorderId?: string;
  craneId?: string;
  workerId?: string;
}

interface UrenFilterChipsProps {
  value: UrenFilterChipState;
  onChange: (next: UrenFilterChipState) => void;
  related: {
    users: { id: string; name: string }[];
    workorders: { id: string; number: string }[];
    cranes: { id: string; number: string }[];
  };
}

export function UrenFilterChips({ value, onChange, related }: UrenFilterChipsProps) {
  const { t } = useTranslation();
  const userById = new Map(related.users.map((u) => [u.id, u]));
  const woById = new Map(related.workorders.map((w) => [w.id, w]));
  const crById = new Map(related.cranes.map((c) => [c.id, c]));

  function clear(key: keyof UrenFilterChipState) {
    const next = { ...value };
    delete next[key];
    onChange(next);
  }

  return (
    <div className="flex items-center gap-2 flex-wrap">
      {value.costCenterId && (
        <Chip removable onRemove={() => clear("costCenterId")}>
          {`${t("admin.uren.filters.cost-center")} ${value.costCenterId}`}
        </Chip>
      )}
      {value.workorderId && (
        <Chip removable onRemove={() => clear("workorderId")}>
          {`${t("admin.uren.filters.workorder")} ${woById.get(value.workorderId)?.number ?? value.workorderId}`}
        </Chip>
      )}
      {value.craneId && (
        <Chip removable onRemove={() => clear("craneId")}>
          {`${t("admin.uren.filters.crane")} ${crById.get(value.craneId)?.number ?? value.craneId}`}
        </Chip>
      )}
      {value.workerId && (
        <Chip removable onRemove={() => clear("workerId")}>
          {`${t("admin.uren.filters.worker")} ${userById.get(value.workerId)?.name ?? value.workerId}`}
        </Chip>
      )}
    </div>
  );
}
